// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"A87lA","img":"KRQ9s","imgWrapper":"EFFJc","align_center":"TygBu","keepRatio":"WgrXI","show":"TFiAa"};